<template>
  <div class="product-item-details" v-bind:class="[product.align == 'left' ? 'align-left' : 'align-right']">

    <div class="product-item-details-header" v-html="product.name"></div>
    <span class="patent-pending-badge" v-if="product.patentPending">PATENT PENDING</span>

    <div class="product-item-details-body" v-if="product.description">
      <span class="beta-badge" v-if="product.isBeta">BETA</span>
      {{ product.description }}
    </div>

    <div class="attach-item-feature-toggle-mobile" v-on:click="toggleFeatures" v-if="!showFeaturesMobile">
      <span v-if="!showFeaturesMobile">Learn more <i class="fa fa-plus-square"></i></span>
      <!-- <span v-if="showFeaturesMobile">Close <i class="fa fa-minus-square"></i></span> -->
    </div>
    <span class="attach-item-feature-wrapper" v-bind:class="[showFeaturesMobile ? 'mobile-show' : 'mobile-hide']" v-on:click="toggleFeatures">
      <div class="attach-item-feature" v-for="feature in product.features" v-html="feature"></div>
    </span>

    <a href="#contact-footer" v-on:click="clickProductButton(product)" class="attach-item-request-demo-button">Request a demo</a>

    <div class="learn-more-link" v-if="product.learnMore" v-bind:class="[product.align == 'left' ? 'learn-more-left' : 'learn-more-right']">
      {{ product.learnMore.text }}
      <a :href="product.learnMore.href">Learn more <i class="fa fa-arrow-right"></i> </a>
    </div>


  </div>
</template>

<script>

import eventDispatcher from '../../events/dispatch'

export default {
  props: [ 'product' ],
  data() {
    return {
      showFeaturesMobile: false
    }
  },
  mounted() {},
  methods: {
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    },
    toggleFeatures() {
      this.showFeaturesMobile = !this.showFeaturesMobile
    },
    clickProductButton(product) {
      let message = product.clickMessage
      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(message)

      eventDispatcher('requestDemoClicked', {
        product: product.slug
      })

      this.resetScroll()
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .product-item-details {
    vertical-align: top;
    display: inline-block;
    font-family: Work Sans,sans-serif;
    font-size: 22px;
    width: 40%;
  }

  @media only screen and (max-width: 650px) {
    .product-item-details {
      display: block;
      width: 100%;
      margin: 0 auto;
    }
  }

  .product-item-details-header {
    text-align: left;
    color: #808080b0;
    font-weight: lighter;
    letter-spacing: 2px;
    font-size: 28px;
  }

  @media only screen and (max-width: 650px) {
    .product-item-details-header {
      text-align: center;
    }
  }


  .product-item-details-body {
    font-size: 18px;
    text-align: left;
    white-space: normal;
    padding: 12px 0;
    color: #5d5b5b;
  }

  @media only screen and (max-width: 650px) {
    .product-item-details-body {
      text-align: center;
    }
  }

  .attach-item-feature-wrapper {

  }

  .attach-item-feature {
    font-size: 16px;
    text-align: left;
    border-left: 3px solid #ececec;
    padding: 2px 12px;
    margin: 12px 4px;
    color: #9c9b9b;
    white-space: normal;
  }

  @media only screen and (max-width: 650px) {
    .attach-item-feature {
      text-align: center;
      border: none;
    }
  }

  .align-right {
    margin-left: 72px;
  }

  .align-left {
    margin-right: 72px;
  }

  @media only screen and (max-width: 650px) {
    .align-right {
      margin-left: auto;
    }
    .align-left {
      margin-right: auto;
    }
  }

  .attach-item-request-demo-button {
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
    color: white;
    font-size: 22px;
    width: 280px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin-top: 24px;
    display: block;
    cursor: pointer;
    box-shadow: 0px 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
  }

  @media only screen and (max-width: 650px) {
    .attach-item-request-demo-button {
      /* margin: 0 auto; */
      /* width: 95%; */
      display: none;
    }
  }

  .attach-item-feature-toggle-mobile {
    display: none;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: lighter;
    letter-spacing: 2px;
    padding: 8px;
    border: 1px solid;
    margin-bottom: 12px;
    border-radius: 2px;
    color: #00bfbd;
    margin-top: 12px;
  }

  @media only screen and (max-width: 650px) {
    .attach-item-feature-toggle-mobile {
      display: block;
    }
  }

  .mobile-hide {
    display: block;
  }

  .mobile-show {
    display: block;
  }

  @media only screen and (max-width: 650px) {
    .mobile-hide {
      display: none;
    }

    .mobile-show {
      display: block;
      display: block;
    }
  }

  .beta-badge {
    background: #52b3ff;
    padding: 0px 4px;
    color: white;
    border-radius: 4px;
  }

  .patent-pending-badge {
    display: block;
    font-size: 12px;
    background: #b1b1b1;
    color: white;
    margin-top: 8px;
    width: 133px;
    text-align: center;
    padding: 2px;
    letter-spacing: 1px;
    border-radius: 2px;
  }

  @media only screen and (max-width: 650px) {
    .patent-pending-badge {
      margin: 12px auto;
    }
  }

  .learn-more-link {
    display: block;
    margin-top: 24px;
    font-size: 12px;
    white-space: normal;
    color: #676767;
    text-align: left;
  }

  .learn-more-link a {
    color: #00bfbd;
    text-decoration: underline;
  }

  .learn-more-link a:hover {
    color: #333;
    transition: ease-in-out 0.225s;
  }

</style>



// WEBPACK FOOTER //
// ProductDetailsComponent.vue?51f2e8e5